export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/get-on-android.3fe6a345.svg","height":33,"width":109,"blurWidth":0,"blurHeight":0};